'use strict';

/**
 * @classname BeginnerTabSelect
 * @classdesc LP初めての方へのタブの切り替え
 */
export default class BeginnerTabSelect {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 * @param {instance} controller - controller オブジェクト
	 */
	constructor($e) {
		console.log('BeginnerTabSelect.constructor');
		this._$e = $e;
		this._$target = $(`#${$e.attr('data-target')}`)
		$e.on('click', () => this.onClick());
	};


	/**
	 * クリックイベントのコールバック
	 *
	 * @memberof BeginnerTabSelect
	 * @return {undefined}
	 */
	onClick() {
		console.log('BeginnerTabSelect.onClick');
		if (!this._$e.hasClass('active')) {
			this._$e.closest('.list--tab-2color').find('.tab').removeClass('active');
			this._$e.addClass('active');
			this._$target.removeClass('hide')
			//this._$target.siblings('.image-box').addClass('hide')
			this._$target.siblings().addClass('hide')
		}
	};
};